import React from "react";
import { useState, useEffect, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import FalconCardHeader from "../common/FalconCardHeader";
import WizardError from "../auth/register/WizardError";
import ButtonIcon from "../common/ButtonIcon";
import classNames from "classnames";
import NumberFormat from "react-number-format";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { PreloadState } from "../UI/preloading/PreloadState";
import { fetchCondominiumBalance } from "../../helpers/api/condominium";
import {
  createPaymentFund,
  fetchCondominiumFunds,
} from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { useHistory, useParams } from "react-router-dom";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { Toast } from "../UI/toast/Toast";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreatePaymentReserveFundForm = ({
  setRedirect,
  setRedirectUrl,
}) => {
  const moduleBase = useModuleBase();

  const history = useHistory();
  const { id } = useParams();
  const { baseCurrency } = useContext(CurrencyContext);
  const {
    register,
    handleSubmit,
    setValue,
    errors,
    control,
    formState: { isSubmitting },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  const [anyfund, setAnyFund] = useState(false);
  const {
    condominium: { selectedCondominium },
    auth: {
      user: { role },
    },
  } = useSelector((state) => state);



  const create = async (values) => {
    const {
      amount,
      reserve_fund_id,
    } = values;
    try {
      const formData = new FormData();

      formData.append("condominium_id", id);
      formData.append("amount", amount);

      formData.append("reserve_fund_id", reserve_fund_id);

      const { code } = await createPaymentFund(formData);

      console.log(code);

      if (code === SUCCESS_RESPONSE.CREATED) {
        setRedirectUrl(`/dashboard/funds/${id}/cash`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Ingreso registrado exitosamente.`,
        });
      }
    } catch (error) {
      console.log(error);
      handleErrorMessage(error);
    }
  };

  const [funds, setFunds] = useState([]);
  const fetchApi = async () => {
    const response = await fetchCondominiumBalance(selectedCondominium);
    setFunds(response.data && response.data.length >= 0 ? response.data : []);
  };
  useEffect(() => {
    fetchApi();
  }, []);

  const [selectFunds, setSelectFunds] = useState([]);
  const fetchApiFunds = async () => {
    const response = await fetchCondominiumFunds(selectedCondominium);
    setSelectFunds(
      response.data && response.data.length >= 0 ? response.data : []
    );
    console.log("fondos", response.data);
  };
  useEffect(() => {
    fetchApiFunds();
  }, []);

  const renderForm = () => (
    <>
      <FalconCardHeader title="Detalle de la transferencia" light={false} />
      <CardBody>
        <Row form>
          <Col sm tag={FormGroup}>
            <Label for="acronym">Transferir a </Label>
            <Controller
              name="reserve_fund_id"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Seleccione un fondo de reserva",
                },
              }}
              render={({ onChange, name, value }) => (
                <Input
                  type="select"
                  name="reserve_fund_id"
                  value={value || "Selecciona"}
                  onChange={(event) => {
                    setValue("reserve_fund_id", event.target.value);
                    onChange(`${event.target.value}`);
                  }}
                  innerRef={register("reserve_fund_id", {
                    required: {
                      value: true,
                      message: "Seleccione un fondo de reserva",
                    },
                  })}
                  className={classNames({
                    "border-danger": errors["reserve_fund_id"]?.message,
                  })}
                >
                  {selectFunds.length > 0 ? (
                    <>
                      <option disabled value="Selecciona">
                        ---
                      </option>
                      {selectFunds.map((fund) => (
                        <option key={fund.id} value={fund.id}>
                          {fund.name}
                        </option>
                      ))}
                    </>
                  ) : (
                    <option disabled value="">
                      No hay fondos
                    </option>
                  )}
                </Input>
              )}
            />
            <WizardError
              error={errors["reserve_fund_id"]?.message}
              className="fs--1 font-weight-normal d-block"
            />
          </Col>
        </Row>


        <Row form>
          <Col sm tag={FormGroup}>
            <Label for="acronym">Monto</Label>

            <Controller
              name="amount"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Ingresar el monto",
                },
              }}
              render={({ onChange, name, value }) => (
                <NumberFormat
             
                  onValueChange={({ value }) => {
                    setValue("amount", Number(value));
                    onChange(`${value}`);
                  }}
                  innerRef={register({
                    required: { value: true, message: "Ingresar el monto" },
                  })}
                  name="amount"
                  id="amount"
                  fixedDecimalScale={true}
                  prefix={`${baseCurrency.symbol} `}
                  decimalScale={2}
                  className={`${
                    errors["amount"]?.message ? "border-danger" : ""
                  } form-control`}
                  placeholder="Monto"
                  thousandSeparator={true}
                  renderText={(value, props) => <div {...props}>{value}</div>}
                />
              )}
            />

            <WizardError
              error={errors["amount"]?.message}
              className="fs--1 font-weight-normal d-block"
            />
          </Col>
        </Row>

        <Row>
          <Col className="d-flex justify-content-end">
            <ButtonIcon
              color="falcon-default"
              className="ml-auto px-5 mr-2"
              icon={faUndo}
              onClick={
                () =>
                  history.push({
                    pathname: `/dashboard/funds/${id}/cash`,
                  })

                /*       setRedirectUrl(`/dashboard/${moduleBase}/${id}/common-costs`);
                setRedirect(true); */
              }
              iconAlign="right"
              transform="down-1 shrink-4"
            >
              Cancelar
            </ButtonIcon>
            <ButtonIcon
              data-testid="submit-button"
              color="primary"
              className="px-5 ml-2"
              type="submit"
              icon="save"
              iconAlign="right"
              /*  disabled={Object.keys(errors).length > 0} */
              transform="down-1 shrink-4"
            >
              Guardar
            </ButtonIcon>
          </Col>
        </Row>
      </CardBody>
    </>
  );

  return (
    <Card
      data-testid="form"
      tag={Form}
      reserve={anyfund}
      onSubmit={handleSubmit(create)}
      className="bg-light"
    >
      <PreloadState loading={isSubmitting} message="Guardando ingreso común...">
        {renderForm()}
      </PreloadState>
    </Card>
  );
};

export default CreatePaymentReserveFundForm;
